export const POPUP_PARAM_KEY = 'popup';
export const DAILY_POST_PARAM_KEY = 'dailyPostId';
